import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
// import { render } from 'react-dom';
// import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
// import { ConnectedRouter } from 'connected-react-router';
import {
  BrowserRouter,
} from 'react-router-dom';

// Порядок важен: skeleton.css ПОСЛЕ main.scss перекрыл бы наши токены цветов
// (--base-color/--highlight-color из _tables.scss). Поэтому сначала библиотечный css,
// затем main.scss — наш override побеждает по специфичности (.react-loading-skeleton).
import 'react-loading-skeleton/dist/skeleton.css';
import './scss/main.scss';

import { Provider } from 'mobx-react';
import { store as reduxStore } from './lib/redux';
import theRoutes from './lib/router/routes';
import App from './App';
import * as stores from './lib/mobx/stores';
import ErrorBoundary from './components/errors/ErrorBoundary';

window.avtoappReduxStore = reduxStore;

class Root extends Component {
  render() {
    return (
      <ErrorBoundary name='global'>
        <Provider { ...stores }>
          <ReduxProvider store={ reduxStore }>
            <BrowserRouter>
              <App>{ theRoutes }</App>
            </BrowserRouter>
          </ReduxProvider>
        </Provider>
      </ErrorBoundary>
    );
  }
}

// const container = document.getElementById('root');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

/* render(<Root />, createRoot(document.getElementById('root')));

// Before
import { render } from 'react-dom';
const container = document.getElementById('app');
render(<App tab="home" />, container);

// After
import { createRoot } from 'react-dom/client';
const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App tab="home" />); */

/* import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/
